import React from "react";
// import ClearButton from "../../../../../learning/presentational/body/input/notepad/ClearButton";
import Tip from "./Tip";

const Notepad = ( props ) => {

  return (
    <div className="keypadBox active">
      <div className="keypad_wrap">
        <div className="keypad_gm notes">
          <div className="mid_area">
            <div className="notes_cont" />
          </div>
          <div className="lower_area">{ props.children }</div>
          {/* <div className="btn_area"><ClearButton /></div> */}
          <Tip />
        </div>
      </div>
    </div>
  );

};

export default Notepad;
